import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BILLER_COLOR_MAP } from 'src/app/billers/configs/biller-color-map.config';
import { LOGO_CDN_URL, LOGO_SUFFIX } from '../../configs/biller-logo-config';
import { ArchiveStatus } from '../../../billers/models/archive-status';

@Component({
standalone: false,
  selector: 'app-biller-logo',
  styleUrls: ['./biller-logo.component.scss'],
  templateUrl: './biller-logo.component.html',
})
export class BillerLogoComponent implements OnChanges {
  @Input() billerCode: string;
  @Input() class: string;
  @Input() size: number;

  public readonly logoCdnUrl = LOGO_CDN_URL;
  public readonly logoSuffix = LOGO_SUFFIX;
  public readonly billerColorMap = BILLER_COLOR_MAP;

  public billerNameShort: string;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    const billerCode = changes?.billerCode;
    if (billerCode?.currentValue && billerCode?.previousValue !== billerCode?.currentValue) {
      this.billerNameShort = billerCode.currentValue?.substring(0, 1);
    }
  }

  protected readonly archiveStatus = ArchiveStatus;
}
